import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getCarteles,
  insertCartel,
  updateCartel,
  deleteCartel,
  getCartelById,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_CARTELES() {
  try {
    const cartelesData = yield call(getCarteles)
    if (cartelesData.ok) {
      yield put({
        type: actions.CARTELES_LOAD_SUCCEEDED,
        payload: cartelesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar carteles')
      put({
        type: actions.CARTELES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CARTELES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CARTEL(action) {
  try {
    const cartelObj = yield call(insertCartel, action.payload)
    if (cartelObj.ok) {
      putMessage(messageType.SUCCESS, 'Cartel creado correctamente')
      yield put({
        type: actions.CARTEL_INSERT_SUCCEEDED,
        payload: cartelObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Cartel')
      yield put({
        type: actions.CARTEL_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Cartel')
    yield all([
      put({
        type: actions.CARTEL_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CARTEL(action) {
  try {
    const cartelObj = yield call(updateCartel, action.payload)
    if (cartelObj.ok) {
      putMessage(messageType.SUCCESS, 'Cartel modificado correctamente')
      yield put({
        type: actions.CARTEL_UPDATE_SUCCEEDED,
        payload: cartelObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Cartel')
      yield put({
        type: actions.CARTEL_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Cartel')
    yield all([
      put({
        type: actions.CARTEL_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CARTEL(action) {
  try {
    const cartelResult = yield call(deleteCartel, action.payload)
    if (cartelResult.ok) {
      putMessage(messageType.SUCCESS, 'Cartel eliminado correctamente')
      yield put({
        type: actions.CARTEL_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Cartel')
      yield put({
        type: actions.CARTEL_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Cartel')
    yield all([
      put({
        type: actions.CARTEL_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CARTEL_BY_ID(action) {
  try {
    const cartelData = yield call(getCartelById, action.payload)
    if (cartelData.ok) {
      yield put({
        type: actions.CARTEL_LOAD_BY_ID_SUCCEEDED,
        payload: cartelData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar cartel')
      put({
        type: actions.CARTEL_LOAD_BY_ID_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CARTEL_LOAD_BY_ID_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CARTELES_LOAD_REQUESTED, GET_CARTELES),
    takeEvery(actions.CARTEL_LOAD_BY_ID_REQUESTED, GET_CARTEL_BY_ID),
    takeEvery(actions.CARTEL_INSERT_REQUESTED, INSERT_CARTEL),
    takeEvery(actions.CARTEL_UPDATE_REQUESTED, UPDATE_CARTEL),
    takeEvery(actions.CARTEL_DELETE_REQUESTED, DELETE_CARTEL),
  ])
}
